import React from 'react';
import PropTypes from 'prop-types';
import { Image, MediaBlock } from '../../Atoms';
import { RawHtml } from '../../Utilities';

const Hero = ({ value }) => {
  if (!value) return null;

  const { heading, subHeading, intro, cta, image, media, mobileImage, imagePosition } = value;

  const hasMedia = media || image;

  const renderMedia = (mediaSource) => {
    if (!mediaSource) return null;
    if (mediaSource.type === 'image') return <Image image={mediaSource} fit="cover" />;
    return <MediaBlock media={mediaSource} fit={mediaSource.type === 'diagram' ? 'contain' : 'cover'} />;
  };

  const textContent = (
    <div className="content-element">
      <div className="stack stack-normal">
        {heading && <div className="text-hero-title text-neutral-800">{heading}</div>}
        {subHeading && <div className="text-hero-support text-neutral-600">{subHeading}</div>}
        {intro && <div className="text-hero-intro text-neutral-700">
          <RawHtml html={intro} />
          </div>}
        {cta?.text && cta?.url && (
          <div className="mt-2xl">
            <a href={cta.url} className="btn btn-solid btn-lg">
              {cta.text}
            </a>
          </div>
        )}
      </div>
    </div>
  );

  // imagePosition: false (default) — overlay mode
  if (!imagePosition) {

    // Condition: mobileImage present → swap background per breakpoint
    const hasMobileSwap = !!mobileImage;

    return (
      <section className="section section-full section--centered-narrow">
        <div className="section__inner">
          <div className="viewport-90">
            <div className="media-element media-element--overlay">

              {hasMobileSwap ? (
                <>
                  {/* Mobile image — shown below md, hidden above */}
                  <div className="md:hidden">
                    {renderMedia(mobileImage)}
                  </div>
                  {/* Desktop image — hidden below md, shown above */}
                  <div className="hidden md:block h-full">
                    {renderMedia(media || image)}
                  </div>
                </>
              ) : (
                hasMedia && renderMedia(media || image)
              )}

              <div className="media-element__content items-center justify-center">
                <div className="media-element__inner">
                  {textContent}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }

  // imagePosition: true — stacked mode: text above, media fills remaining viewport
  return (
    <section className="section section-full section--centered-narrow">
      <div className="section__inner">
        <div className="viewport-90">
          {textContent}
          {hasMedia && (
            <div className="media-element">
              {renderMedia(media || image)}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    intro: PropTypes.string,
    imagePosition: PropTypes.bool,
    cta: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
    image: PropTypes.object,
    media: PropTypes.object,
    mobileImage: PropTypes.object,
  }),
};

export default Hero;